import React from 'react'

import { Field } from 'formik'

import { Form, Col, Button } from '_zari/core'
import { ZariContext } from '_zari/context'

import * as ProductoCrud from 'services/producto.service'

const CodigoFormGroup = ({ iError, iTouched, fIsSubmitting, values, setValues, handleChange, flagEdicion }) => {
  const __zariContext = React.useContext(ZariContext)

  const [flagGenerando, setFlagGenerando] = React.useState(false)
  const [flagEditando, setFlagEditando] = React.useState(false)

  React.useEffect(() => {
    if (!flagEdicion && !values.codigo) {
      setFlagGenerando(true)
      ProductoCrud.getNuevoCodigo()
        .then(({ data }) => {
          setFlagGenerando(false)
          setValues(prev => ({
            ...prev,
            codigo: data.nuevoCodigo,
            codigoGeneradoFlag: true
          }))
        })
        .catch(({ data: { error } }) => {
          setFlagGenerando(false)
          __zariContext.toast('error', error)
        })
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const clickEditar = React.useCallback(() => {
    setFlagEditando(true)
  }, [])

  return (
    <Form.Group>
      <Form.Label text='CÓDIGO' htmlFor='input-codigo' md={3} alignRightAt='md' />
      <Col md={9}>
        <Form.InputGroup>
          <Field name='codigo'>
            {({ field }) => (
              <Form.InputText
                {...field}
                id='input-codigo'
                isInvalid={iTouched && iError}
                disabled={flagEdicion || (!flagEditando && !flagEdicion)}
                onChange={e => {
                  handleChange(e)
                  setValues(prev => ({
                    ...prev,
                    codigo: e.target.value,
                    codigoGeneradoFlag: false
                  }))
                }}
              />
            )}
          </Field>
          {!flagEdicion && (
            <Form.InputGroup.Append>
              <Button
                disabled={fIsSubmitting || flagGenerando || flagEditando}
                color='secondary'
                onClick={clickEditar}
              >
                Editar
              </Button>
            </Form.InputGroup.Append>
          )}
          {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
        </Form.InputGroup>
      </Col>
    </Form.Group>
  )
}

export default React.memo(CodigoFormGroup)
